<script lang="ts">
  import Button from "$lib/components/Button/Button.svelte"
  import { MoveRight } from "lucide-svelte"
  import { getRequirement } from "$lib/components/Widget2/utils"
  import userStore from "$lib/stores/userStore"
  import { generateReferralLink } from "$lib/utils/referral"
  import type { Competition } from "$lib/types/competition"
  import { t, getCurrentLanguage } from "$lib/utils/i18n"

  interface Props {
    action: any
    competition: Competition
    processAction: (action: any) => void
  }

  let { action, competition, processAction }: Props = $props()

  const language = getCurrentLanguage()

  let isLoading = $state(false)
  let xLinkUrl = $state("")

  const entries = getRequirement(action, "Entries") || 0

  let entryPluralized = $derived(
    t("widget_action_entries", {
      count: Number(entries),
    }),
  )

  async function handleGenerateReferral() {
    try {
      return await generateReferralLink({
        user: $userStore.user,
        competition: competition,
      })
    } catch (error) {
      console.error("Error generating referral link:", error)
    }
  }

  async function getXLink(action) {
    try {
      const actionName = action.actions.name

      switch (actionName) {
        case "Repost on X": {
          const postUrl = getRequirement(action, "Post Url") || ""
          const parts = postUrl.split("/status/")
          const tweetId = parts.length > 1 ? parts[1] : ""
          return `https://x.com/intent/retweet?tweet_id=${tweetId}`
        }

        case "View a Post on X":
          return getRequirement(action, "Post Url") || ""

        case "Follow on X":
          return `https://x.com/intent/follow?screen_name=${
            getRequirement(action, "Username") || ""
          }`

        case "Post on X": {
          const referralLink = (await handleGenerateReferral()) || ""
          let text = getRequirement(action, "Post")
          if (!text) {
            text = "I've just entered this giveaway! Check it out!"
          }
          return `https://x.com/intent/tweet?text=${encodeURIComponent(text)}+${encodeURIComponent(referralLink)}`
        }

        default:
          return ""
      }
    } catch (error) {
      console.error("Error generating X link:", error)
      return "" // Return empty string on any error
    }
  }

  $effect(() => {
    isLoading = true
    getXLink(action).then((link) => {
      xLinkUrl = link
      isLoading = false
    })
  })
</script>

<div class="bg-white rounded-lg p-4 shadow-lg">
  <div class="mb-4">
    <h4 class="text-sm font-medium mb-2">
      {t("widget_action_worth", { count: entries, entries: entryPluralized })}
    </h4>
  </div>

  <a
    href={xLinkUrl}
    target="_blank"
    class="block"
    onclick={() => processAction(action)}
  >
    <Button
      variant="default"
      class="w-full bg-black text-white hover:bg-gray-800 flex items-center justify-center gap-2"
      {isLoading}
      disabled={isLoading || !xLinkUrl}
    >
      {#if isLoading}
        Loading...
      {:else}
        {(action.selectedAction || action.actions)?.translations?.[language]
          ?.name}
        <MoveRight />
      {/if}
    </Button>
  </a>
</div>
